//animation parallax content
(function ($) {
    $(document).ready(function () {
        if ($(".group-11").length) {
            $(".group-11").parallaxContent({
                shift: 30,
                duration: 1.5
            });
        }

        if ($(".group-13").length) {
            $(".group-13").parallaxContent({
                shift: 40,
                duration: 1.5
            });
        }

        if ($(".group-13-1").length) {
            $(".group-13-1").parallaxContent({
                shift: -40,
                duration: 1.5
            });
        }

        if ($(".group-14").length) {
            $(".group-14").parallaxContent({
                shift: 50,
                duration: 1
            });
        }
    });
})(jQuery);